import { render, staticRenderFns } from "./IconTeamAssessment.vue?vue&type=template&id=36a2af74"
import script from "./IconTeamAssessment.vue?vue&type=script&lang=js"
export * from "./IconTeamAssessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports